/**
 * @generated SignedSource<<3871807459f56d1593bca45385e48b8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
import { FragmentRefs } from "relay-runtime";
export type UserSelect_viewer$data = {
  readonly selectUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly internalAttributes: {
          readonly manager: {
            readonly email: string;
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isGuest: boolean;
            readonly lastName: string;
            readonly relationshipToViewer: AncestryRelationship | null;
          } | null;
        } | null;
        readonly isGuest: boolean;
        readonly lastName: string;
        readonly relationshipToViewer: AncestryRelationship | null;
      };
    }>;
  } | null;
  readonly user: {
    readonly id: string;
  };
  readonly " $fragmentType": "UserSelect_viewer";
};
export type UserSelect_viewer$key = {
  readonly " $data"?: UserSelect_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSelect_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationshipToViewer",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "doesNotReportUnder"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idIn"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isGuests"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isManager"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ranked"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "reportsTo"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "reportsUnder"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSelect_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "selectUsers",
      "args": [
        {
          "kind": "Variable",
          "name": "doesNotReportUnder",
          "variableName": "doesNotReportUnder"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 25
        },
        {
          "kind": "Variable",
          "name": "idIn",
          "variableName": "idIn"
        },
        {
          "kind": "Variable",
          "name": "isGuests",
          "variableName": "isGuests"
        },
        {
          "kind": "Variable",
          "name": "isManager",
          "variableName": "isManager"
        },
        {
          "kind": "Variable",
          "name": "ranked",
          "variableName": "ranked"
        },
        {
          "kind": "Variable",
          "name": "reportsTo",
          "variableName": "reportsTo"
        },
        {
          "kind": "Variable",
          "name": "reportsUnder",
          "variableName": "reportsUnder"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserInternalAttributes",
                  "kind": "LinkedField",
                  "name": "internalAttributes",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "manager",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v7/*: any*/),
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "39cde99f89927a8a13cf678869cc6593";

export default node;
